import { appConfig } from "src/config";
import { createForwardParams, getSearchQuery } from "src/utils/urlParams";

export default {
  healthReportFeedback() {
    const queryParams = createForwardParams();
    window.location.href = `${
      appConfig.HEALTH_REPORT_URL
    }/health-report/feedback${getSearchQuery(queryParams)}`;
  },
};
